import React, { useEffect, useState } from "react";
import { Gift, Copy, Check, Users } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";

export default function ReferralPanel() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => { api.get("/member/referral").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;

  const link = `${window.location.origin}/join?ref=${data.code}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); } catch (e) {}
    setCopied(true); toast.success(t("Invite link copied", "Lien copié"));
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div data-testid="referral-panel" className="rounded-[2rem] bg-card border border-primary/10 p-8 md:p-10">
      <div className="flex items-center gap-3">
        <span className="w-11 h-11 rounded-full bg-secondary/15 text-secondary flex items-center justify-center"><Gift size={20} /></span>
        <div>
          <h3 className="font-display text-2xl font-semibold text-primary">{t("Bring a friend", "Invitez une amie")}</h3>
          <p className="text-sm text-muted-foreground">{t("When a friend joins with your link, you get", "Quand une amie rejoint avec votre lien, vous obtenez")} <b className="text-secondary">{data.reward_months} {t(data.reward_months === 1 ? "free month" : "free months", data.reward_months === 1 ? "mois offert" : "mois offerts")}</b>.</p>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3 mt-6">
        <div className="flex-1 min-w-[240px] rounded-full bg-muted/50 border border-primary/10 px-5 py-3 text-sm text-foreground/80 truncate" data-testid="referral-link">{link}</div>
        <button onClick={copy} data-testid="referral-copy-btn" className="flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-3 text-sm font-semibold hover:bg-secondary transition-colors">
          {copied ? <Check size={15} /> : <Copy size={15} />} {copied ? t("Copied", "Copié") : t("Copy link", "Copier")}
        </button>
      </div>

      <div className="flex items-center gap-2 mt-5 text-sm text-foreground/70">
        <Users size={16} className="text-secondary" />
        <span data-testid="referral-count">{data.count}</span> {t(data.count === 1 ? "friend has joined" : "friends have joined", data.count === 1 ? "amie a rejoint" : "amies ont rejoint")}
      </div>
    </div>
  );
}
